export const env = process.env.VITE_DEPLOY_ENV;
export const appTitle = process.env.VITE_APP_TITLE;

// 호스팅 도메인 기반으로 chat URL 결정
// 예: studio.flowing.space → talks.flowing.space
//     studio.dev.flowing.space → talks.dev.flowing.space
//     partner.sodomall.store → talks.sodomall.store
//     shop3.io → talks.shop3.io
const CHAT_HOSTING_PREFIXES = ['studio', 'partner', 'talks'];

const getFlowingChatUrl = () => {
    if (typeof window === 'undefined') {
        return process.env.VITE_SERVICE_LINK_CHAT_URL;
    }
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || /^[\d.]+$/.test(hostname)) {
        return process.env.VITE_SERVICE_LINK_CHAT_URL;
    }

    const parts = hostname.split('.');
    const baseParts = parts.length > 2 && CHAT_HOSTING_PREFIXES.includes(parts[0]) ? parts.slice(1) : parts;
    return `https://talks.${baseParts.join('.')}`;
};

// 호스팅 도메인 기반으로 소셜 로그인 redirect URL 결정
// 예: studio.dev.flowing.space → https://studio.dev.flowing.space/social/naver
//     studio.dev.sodu.pro      → https://studio.dev.sodu.pro/social/naver
//     studio.flowing.space     → https://studio.flowing.space/social/naver
//     studio.sodu.pro          → https://studio.sodu.pro/social/naver
const getSocialRedirectUrl = (provider, fallback) => {
    if (typeof window === 'undefined') return fallback;
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || /^[\d.]+$/.test(hostname)) {
        return fallback;
    }

    return `${window.location.origin}/social/${provider}`;
};

export const services = {
    flowing_mall_url: process.env.VITE_SERVICE_LINK_MALL,
    flowing_space_console: process.env.VITE_SERVICE_LINK_CONSOLE,
    flowing_studio: process.env.VITE_SERVICE_LINK_STUDIO,
    recruit_seller: process.env.VITE_SERVICE_LINK_RECRUIT_SELLER,
    flowing_chat_url: getFlowingChatUrl(),
    social: {
        naver_client_id: process.env.VITE_NAVER_CLIENT_ID,
        naver_redirect_url: getSocialRedirectUrl('naver', process.env.VITE_NAVER_REDIRECT_URL),
        kakao_client_id: process.env.VITE_KAKAO_CLIENT_ID,
        kakao_redirect_url: getSocialRedirectUrl('kakao', process.env.VITE_KAKAO_REDIRECT_URL),
        apple_client_id: process.env.VITE_APPLE_CLIENT_ID,
        apple_redirect_url: process.env.VITE_APPLE_REDIRECT_URL,
    },
};

// 소도몰 파트너 도메인인지 확인하는 함수
const isSodomallPartnerDomain = () => {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname;
    return hostname === 'partner.sodomall.store' || hostname === 'partner.dev.sodomall.store';
};

// 호스팅 도메인 기반으로 common API URL 결정
// 예: studio.flowing.space → common.api.flowing.space
//     studio.dev.flowing.space → common.api.dev.flowing.space
//     partner.sodomall.store → common.api.sodomall.store
//     shop3.io → common.api.shop3.io
const HOSTING_PREFIXES = ['studio', 'partner'];

const getCommonApiUrl = () => {
    if (typeof window === 'undefined') {
        return process.env.VITE_APP_COMMON_API_URL || 'https://common.api.dev.flowing.tel';
    }
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || /^[\d.]+$/.test(hostname)) {
        return process.env.VITE_APP_COMMON_API_URL || 'https://common.api.dev.flowing.tel';
    }

    const parts = hostname.split('.');
    const baseParts = parts.length > 2 && HOSTING_PREFIXES.includes(parts[0]) ? parts.slice(1) : parts;
    return `https://common.api.${baseParts.join('.')}`;
};

// 호스팅 도메인 기반으로 스페이스홈(프로필링크) URL 결정
// 예: studio.flowing.space     → https://flowing.space
//     studio.dev.flowing.space → https://dev.flowing.space
//     studio.sodu.pro          → https://sodu.pro
//     studio.dev.sodu.pro      → https://dev.sodu.pro
export const getSpacehomeUrl = () => {
    if (typeof window === 'undefined') {
        return process.env.VITE_APP_SPACE_URL;
    }
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || /^[\d.]+$/.test(hostname)) {
        return process.env.VITE_APP_SPACE_URL;
    }

    const parts = hostname.split('.');
    const baseParts = parts.length > 2 && HOSTING_PREFIXES.includes(parts[0]) ? parts.slice(1) : parts;
    return `https://${baseParts.join('.')}`;
};

// 호스팅 도메인 기반으로 쇼핑몰 URL 결정 (스페이스홈 + /mall)
export const getFlowingMallUrl = () => {
    if (typeof window === 'undefined') {
        return process.env.VITE_SERVICE_LINK_MALL;
    }
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || /^[\d.]+$/.test(hostname)) {
        return process.env.VITE_SERVICE_LINK_MALL;
    }

    return `${getSpacehomeUrl()}/mall`;
};

export const apiUrls = {
    proxy: process.env.VITE_APP_PROXY_API_URL,
    proxy2: process.env.VITE_APP_PROXY2_API_URL,
    common: getCommonApiUrl(),
    user: process.env.VITE_APP_USER_API_URL,
    mall: process.env.VITE_APP_MALL_API_URL,
    mall_common: process.env.VITE_APP_MALL_COMMON_API_URL,
    mall_main: process.env.VITE_APP_MALL_MAIN_API_URL,
    manager: process.env.VITE_APP_MANAGER_API_URL || 'https://mall.api.dev.flowing.tel',
    matching: process.env.VITE_APP_MATCHING_API_URL,
    studio: process.env.VITE_APP_STUDIO_API_URL,
    chat2: process.env.VITE_APP_CHAT2_API_URL,
    spacehome_url: process.env.VITE_APP_SPACE_URL,
    sodomall_url: process.env.VITE_APP_SODOMALL_URL,
};

export const infra = {
    s3bucket: {
        default: process.env.VITE_APP_STORAGE_BUCKET_NAME || 'flowing-web-resources',
    },
    license: {
        mui_license: process.env.VITE_APP_MUI_PRO_LICENSE,
    },
};

export const payment = {
    nicepay: {
        merchant_key: process.env.VITE_NICEPAY_MERCHANT_KEY,
        payment_mid: process.env.VITE_NICEPAY_PAYMENT_MID,
    },
};

const configure = {
    env,
    services,
    apiUrls,
    infra,
    payment,
};

export default configure;
